const rootpath = process.env.NODE_ENV === 'development' ? '/' : '/RepoList/';
export default rootpath;
